// extracted by mini-css-extract-plugin
module.exports = {"brand":"App_brand__2hP1R","account":"App_account__qyQBs","verticalMenu":"App_verticalMenu__2s3rP"};